import routerOptions0 from "/usr/src/app/content/n3-spas-4be1be69-ad12-46be-84a0-5465fca1372b/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}